/* lystia-gallery.js - галерея PDP (T-E4-02; parity/pdp-tea.md §2; prototype pdp.js buildGallery + оверлей pdpZoom).
   Розмітка: snippets/product-gallery.liquid -> <lystia-gallery class="pgal">; fullscreen - оверлей `pdpZoom` (snippets/overlay.liquid).
   Потрібні: lystia-core.js, lystia-overlay.js (defer, раніше). M: лічильник/крапки на scroll через rAF; тап по слайду -> document.lystiaOverlay.open('pdpZoom', {index});
   zoom: старт з індексу, go(i) smooth (auto при reduced-motion), sync з debounce 40 мс, ←/→ на треку, стрілки (D).
   Тост ♥: fav:change після кліку по .pgal__fav (тоггл робить lystia-favorites.js). */
(function () {
  'use strict';
  var core = document.lystia;
  if (!core) { console.error('[lystia-gallery] потрібен lystia-core.js (document.lystia)'); return; }

  var pendingFav = null;
  document.addEventListener('click', function (e) {
    var fav = e.target.closest && e.target.closest('.pgal__fav');
    if (fav) pendingFav = fav;
  }, true);
  document.addEventListener('fav:change', function (e) {
    var btn = pendingFav;
    pendingFav = null;
    if (!btn || !document.lystiaToast) return;
    var on = !!(e.detail && e.detail.active);
    var text = on ? btn.dataset.textAdded : btn.dataset.textRemoved;
    if (!text) return;
    document.lystiaToast.show(text, {
      icon: on ? 'heart-fill' : 'heart',
      action: on && btn.dataset.favUrl ? { label: btn.dataset.textView, href: btn.dataset.favUrl } : null,
    });
  });

  class LystiaGallery extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.track = this.querySelector('[data-pgal-track]');
      this.counter = this.querySelector('[data-pgal-count]');
      this.dots = this.querySelector('[data-pgal-dots]');
      this.total = parseInt(this.getAttribute('data-total'), 10) || 1;
      this.raf = 0;
      if (!this.track) return;
      this.track.addEventListener('scroll', function () {
        cancelAnimationFrame(self.raf);
        self.raf = requestAnimationFrame(function () {
          var i = Math.round(self.track.scrollLeft / Math.max(1, self.track.clientWidth));
          if (self.counter) self.counter.textContent = i + 1 + ' / ' + self.total;
          if (self.dots) Array.prototype.forEach.call(self.dots.children, function (d, k) { d.classList.toggle('is-on', k === i); });
        });
      }, { passive: true });
      this.addEventListener('click', function (e) {
        var slide = e.target.closest && e.target.closest('[data-pgal-slide]');
        if (!slide || !self.contains(slide) || !document.lystiaOverlay) return;
        document.lystiaOverlay.open('pdpZoom', { index: parseInt(slide.getAttribute('data-pgal-slide'), 10) || 0 });
      });
    }
  }
  if (!customElements.get('lystia-gallery')) customElements.define('lystia-gallery', LystiaGallery);

  /* ---- Fullscreen: DOM будується при відкритті оверлея, тож підключаємось на lystia:overlay-open ---- */
  core.on('overlay-open', function (d) {
    if (!d || d.name !== 'pdpZoom' || !d.panel) return;
    var root = d.panel.querySelector('[data-zoom]');
    var track = root && root.querySelector('[data-zoom-track]');
    if (!track) return;
    var counter = root.querySelector('[data-zoom-count]');
    var prev = root.querySelector('[data-zoom-prev]');
    var next = root.querySelector('[data-zoom-next]');
    var total = parseInt(root.getAttribute('data-total'), 10) || 1;
    var idx = function () { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); };
    var go = function (i) {
      i = Math.max(0, Math.min(total - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: core.reducedMotion() ? 'auto' : 'smooth' });
    };
    var sync = function () {
      var i = idx();
      if (counter) counter.textContent = i + 1 + ' / ' + total;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= total - 1;
    };
    track.addEventListener('scroll', core.debounce(sync, 40), { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx() - 1); }
    });
    if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
    if (next) next.addEventListener('click', function () { go(idx() + 1); });
    setTimeout(function () {
      track.scrollLeft = ((d.props && d.props.index) || 0) * track.clientWidth;
      sync();
    }, 0);
  });
})();
